<template>
  <div class="bg-white p-2">
    <div class="d-flex justify-content-end w-full">
      <button class="btn btn-primary" @click="ExportExcel">
        Xuất Excel
      </button>
    </div>
    <vue-good-table
        :columns="fields"
        :line-numbers="true"
        :rows="tableData"
        :totalRows="totalRecords"
        class="w-100 bg-white mt-2"
        mode="remote"
        @on-per-page-change="onPerPageChange"
        @on-column-filter="onColumnFilter"
        @on-page-change="onPageChange"
    >
      <template slot="table-row" slot-scope="props">
        <span style="line-height: 2rem">
          {{ props.row[props.column.field] }}
        </span>
      </template>
    </vue-good-table>
  </div>
</template>

<script>
import {BButton} from "bootstrap-vue";
import {VueGoodTable} from "vue-good-table";
import "@core/scss/vue/libs/vue-good-table.scss";
import useJwt from "@/auth/jwt/useJwt";
import {$ctx} from "@themeConfig";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import * as Excel from "exceljs";
import moment from "moment";
import {saveAs} from "file-saver";

export default {
  name: "PartnerList",
  components: {BButton, VueGoodTable},
  data() {
    return {
      fields: [
        {
          field: "ID",
          label: "ID",
          tdClass: "text-center",
          filterOptions: {
            enabled: true,
            trigger: "enter"
          }
        },
        {
          field: "FullName",
          label: "Họ và tên",
          filterOptions: {enabled: true, placeholder: "", trigger: "enter"},
          tdClass: "text-center"
        },
        {
          field: "CreatedDate",
          label: "Ngày tạo",
          filterOptions: {enabled: true, placeholder: "", trigger: "enter"},
          tdClass: "text-center"
        },
        {
          field: "Email",
          label: "Email ",
          tdClass: "text-center",
          filterOptions: {enabled: true, placeholder: "", trigger: "enter"}
        },
        {
          field: "Phone",
          label: "Số điện thoại",
          tdClass: "text-center",
          filterOptions: {enabled: true, placeholder: "", trigger: "enter"}
        },
        {
          field: "Content",
          label: "Nội dung",
          tdClass: "text-center",
          filterOptions: {
            enabled: true,
            trigger: "enter"
          }
        }
      ],
      tableData: [],
      totalRecords: 0,
      serverParams: {
        columnFilters: {},
        sort: [],
        page: 1,
        pageSize: 50
      },
      URL_WEB_API: $ctx.API_URL.includes("dev")
          ? "https://itel.dev"
          : "https://itel.vn"
    };
  },
  mounted() {
    this.GetData();
  },
  methods: {
    GetData() {
      this.loading(true);
      useJwt
          .postEx(this.URL_WEB_API + "/api/web/partners", this.serverParams)
          .then(res => {
            this.loading(false);
            this.tableData = res.data.result;
            this.totalRecords = res.data.totalRecords;
            this.tableData.forEach(item => {
              item.CreatedDate = moment(item.CreatedDate).format(
                  "DD/MM/YYYY HH:mm:ss"
              );
            });
          })
          .catch(err => {
            this.loading(false);
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Lỗi không lấy được dữ liệu",
                icon: "AlertTriangleIcon",
                variant: "danger"
              }
            });
          });
    },
    onColumnFilter(params) {
      this.serverParams = {
        columnFilters: params.columnFilters,
        page: 1,
        pageSize: 50
      };
      this.GetData();
    },
    async onPerPageChange(params) {
      this.serverParams.pageSize = params.currentPerPage;
      this.serverParams.page = 1;
      this.GetData();
    },
    async onPageChange(params) {
      this.serverParams.page = params.currentPage;
      this.GetData();
    },
    async ExportExcel() {
      const workbook = new Excel.Workbook();
      const worksheet = workbook.addWorksheet("Sheet1");
      worksheet.columns = [
        {key: "STT", header: "STT"},
        {key: "ID", header: "ID"},
        {key: "FullName", header: "Họ và tên"},
        {key: "CreatedDate", header: "Ngày tạo"},
        {key: "Email", header: "Email"},
        {key: "Phone", header: "Số điện thoại"},
        {key: "Content", header: "Nội dung"}
      ];
      this.tableData.forEach((item, index) => {
        worksheet.addRow({
          STT: index + 1,
          ID: item.ID,
          FullName: item.FullName,
          CreatedDate: item.CreatedDate,
          Email: item.Email,
          Phone: item.Phone,
          Content: item.Content
        });
      });
      const buffer = await workbook.xlsx.writeBuffer();
      const fileType =
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
      const fileExtension = ".xlsx";
      const blob = new Blob([buffer], {type: fileType});
      const fileName = "Danh sách đối tác" + fileExtension;
      saveAs(blob, fileName);
    }
  }
};
</script>

<style lang="scss"></style>
